module.exports = __webpack_public_path__ + "statics/img/cate3-8@2x.112ea630.png";